module.exports = __webpack_public_path__ + "img/team2.6055b9a7.webp";